import { Component, EventEmitter, forwardRef, Inject, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { MmuAnalyticsService } from '../../analytics/mmu-analytics.service';
import { FeatureFlagsMap, MmuFeatureFlagsService } from '../../feature-flags';
import { MmuCookiePreferences } from '../mmu-cookie-preferences';


@Component({
  selector: 'mmu-cookie-preferences-dialog',
  templateUrl: './mmu-cookie-preferences-dialog.component.html',
  styleUrls: ['./mmu-cookie-preferences-dialog.component.scss']
})
export class MmuCookiePreferencesDialog {
  readonly settingsChanged = new EventEmitter<MmuCookiePreferences>();

  settings: MmuCookiePreferences = {
    required: true,
    statistics: false
  };

  constructor(
    private modal: NgbActiveModal,
    // use forwardRef here to resolve a circular dependency between MmuAnalyticsService and MmuCookiePreferencesService - both depend on each other
    @Inject(forwardRef(() => MmuAnalyticsService)) private analyticsService: MmuAnalyticsService,
    private featureFlagsService: MmuFeatureFlagsService,
    private translateService: TranslateService,
    private sanitizer: DomSanitizer
  ) {
  }

  get safeMoreInfoAnchor(): string | null {
    return this.sanitizer.sanitize(
      SecurityContext.HTML,
      `<a href="/user/legal/data-privacy" target="_blank">${this.translateService.instant('cookieSettings.dialog.moreInformation')}</a>`
    );
  }

  /**
   * Accepts only required cookies
   *
   * @param sendEvent whether to send the settingsChanged or not
   */
  acceptRequiredCookies(sendEvent = true): void {
    this.trackCookieBannerInteraction();
    if (sendEvent) {
      this.settings = { required: true, statistics: false };
      this.settingsChanged.emit(this.settings);
    }
    this.modal.close();
  }

  /**
   *  Select all checkboxes and close dialog afterward
   *
   */
  acceptAllCookies(): void {
    this.settings = {
      required: true,
      statistics: true
    };
    this.settingsChanged.emit(this.settings);
    this.modal.close();
  }

  private trackCookieBannerInteraction(): void {
    /**
     * @deprecated FeatureFlagsMap.FFEntGTMTracking
     */
    if (this.featureFlagsService.isFeatureEnabled(FeatureFlagsMap.FFEntGTMTracking)) {
      this.analyticsService.emitCustomEvent('MieleBasic_ConsentInteraction', this.settings.statistics ? 'acceptAll' : 'acceptRequired');
    }
  }
}
